import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoDespesaProdutoService {

  private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getTipoDespesaProdutos(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposdespesaprodutos/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaTipoDespesaProdutos(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/tiposdespesaprodutos/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
